import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as api from "../../../redux/api/chamber/chamber_api";
import * as types from "../../../redux/constants/chamber_constants";

import { Button, Spinner } from "@material-tailwind/react";
import toast from "react-hot-toast";
import ConfirmPayment from "../../../common/shared/ConfirmPayment";

function ChamberPayment({ data }) {
  const [liveLoading, setLiveLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();

  const handleOpen = () => setOpen(!open);

  const handleLive = async (e) => {
    e.preventDefault();

    setLiveLoading(true);
    const formData = {
      productId: data.product.id ? data.product.id : null,
      amount: data.exp_date
        ? data.product.meta.renewal
        : data.product.meta.application,
      serial: data.serial_number,
      year: data.exp_date
        ? new Date(data.exp_date).getFullYear()
        : new Date().getFullYear(),
      chamberId: data.id,
    };

    try {
      const response = await api.chamberPayment(formData);
      const { error, data } = response;

      if (error) {
        setLiveLoading(false);
        toast.error(error);
        setOpen(false);
        dispatch({ type: types.CHAMBER_PAYMENT_FAILURE, payload: error });
      } else {
        const currentItem = Array.isArray(data.chamber)
          ? data.chamber.reduce((latest, item) => {
              if (!latest) return item;

              const latestDate = new Date(latest.createdAt).getTime();
              const itemDate = new Date(item.createdAt).getTime();

              return itemDate > latestDate ? item : latest;
            }, null)
          : null;

        if (currentItem?.new_receipt?.url) {
          window.location.href = currentItem.new_receipt.url;
        }
        setLiveLoading(false);
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    }
  };

  return (
    <>
      <Button color="pink" onClick={handleOpen} disabled={liveLoading}>
        {liveLoading ? <Spinner color="white" /> : "Make Payment"}
      </Button>

      {open && (
        <ConfirmPayment
          open={open}
          setOpen={setOpen}
          title="Electronic"
          amount={
            data.exp_date
              ? data.product.meta.renewal
              : data.product.meta.application
          }
          loading={liveLoading}
          handleConfirm={(e) => handleLive(e)}
          handleClose={handleOpen}
        />
      )}
    </>
  );
}

export default ChamberPayment;
